import { createAsyncThunk } from "@reduxjs/toolkit";
import { IOTPRequest } from "../models/request/IOTPRequest";
import { IPhoneVerifyRequest } from "../models/request/IPhoneVerifyRequest";
import { sendOTPApi, verifyOTPApi } from "./phoneCrud";

export const sendOTPThunk = createAsyncThunk(
  "auth/sendOTP",
  async (queryParams: IOTPRequest, { rejectWithValue }) => {
    try {
      return await sendOTPApi(queryParams);
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Send OTP failed"
      );
    }
  }
);

export const verifyOTPThunk = createAsyncThunk(
  "auth/verifyOTP",
  async (queryParams: IPhoneVerifyRequest, { rejectWithValue }) => {
    try {
      return await verifyOTPApi(queryParams);
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get Form failed"
      );
    }
  }
);
